import { Box, styled, Typography } from '@mui/material';

export const Container = styled(Box)(() => ({
  padding: '32px 16px',
  height: '100vh',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

export const UseHubmeeAppContainer = styled(Box)(() => ({
  padding: '80px 0 ',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  maxWidth: '343px',
}));

export const UseHubmeeAppTitle = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
  color: theme.palette.case.neutral.n800,
  textAlign: 'center',
}));
export const UseHubmeeAppSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.case.neutral.n700,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  textAlign: 'center',
}));

export const LogoWrapper = styled(Box)(({ theme }) => ({
  svg: {
    width: '150px',
    height: '40px',
    path: {
      fill: theme.palette.case.main,
    },
  },
}));

export const DownloadLinkContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '16px',
}));

export const DownloadLinkWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '11px',
}));

export const ContactSupportContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: '100%',
}));

export const SupportText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.case.neutral.n600,
}));
